import {
  LOADING_UI,
  SET_ERRORS,
  CLEAR_ERRORS,
  SET_THEME_MODE,
  LOADING_UI_SUCCESS,
} from "../types/ui.types";

export type uiStateType = {
  loading: boolean;
  errors: null | any;

  themeMode: "dark" | "light";
  // isSubscriptionBased: boolean;
  // menus: {
  //   employee?: string;
  //   facility?: string;
  //   subfacility?: string;
  //   timesheet?: string;
  //   schedule?: string;
  //   employeeinfo?: string;
  //   worktype?: string;
  // };
  // companyName?: string;
};

const initialState: uiStateType = {
  loading: false,
  errors: null,
  themeMode: "light",
};

export default function uiReducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        loading: false,
        errors: null,
      };
    case LOADING_UI:
      return {
        ...state,
        loading: true,
      };

      case LOADING_UI_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SET_THEME_MODE:
      return {
        ...state,
        themeMode: action.payload,
      };
    default:
      return state;
  }
}
